import { render, staticRenderFns } from "./PublisherRegistrationSettingsForm.vue?vue&type=template&id=358350b0"
import script from "./PublisherRegistrationSettingsForm.vue?vue&type=script&lang=js"
export * from "./PublisherRegistrationSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports